import {
  formatAliadosEnTexto,
  formatMontoValue,
  formatMunicipiosValue,
} from './home-datos-metrics.util';
import type {
  HomeDatosContent,
  HomeDatosEstadisticasResponse,
} from '../models/home-datos-content.model';

export const HOME_DATOS_BANCOLDEX_LOGO =
  'assets/img/Home/datos/Logo_bancoldex_green.svg';

export function buildHomeDatosFallback(): HomeDatosContent {
  return {
    usuariosValue: 'Miles',
    usuariosText: 'de negocios ya\nconfían en neocrédito',
    bancoldexText: 'asegura y respalda\nel proceso',
    bancoldexLogoSrc: HOME_DATOS_BANCOLDEX_LOGO,
    municipiosValue: '+800',
    municipiosText: 'municipios cubiertos\nen Colombia',
    montoValue: '+ $10.000 M',
    montoTextLine1: 'gestionados con +20',
    montoTextLine2: 'aliados financieros',
  };
}

export function mapEstadisticasToHomeDatos(
  response: HomeDatosEstadisticasResponse | null | undefined,
  fallback: HomeDatosContent = buildHomeDatosFallback()
): HomeDatosContent {
  if (!isEstadisticasOk(response)) {
    return { ...fallback };
  }

  const ciudades = Number(response.ciudadesAtendidas ?? 0);
  const millones = Number(response.desembolsos ?? 0);
  const aliados = Number(response.aliadosConDesembolso ?? 0);

  return {
    ...fallback,
    municipiosValue: formatMunicipiosValue(ciudades),
    montoValue: formatMontoValue(millones),
    montoTextLine1: `gestionados con ${formatAliadosEnTexto(aliados)}`,
    montoTextLine2: 'aliados financieros',
  };
}

function isEstadisticasOk(
  response: HomeDatosEstadisticasResponse | null | undefined
): response is HomeDatosEstadisticasResponse {
  if (!response) {
    return false;
  }
  return response.exitoso === true || response.exitoso === 'true';
}
